/**
 * Products mega menu — Feminine Balance Line + Feminine Deficiency Line.
 */
(function () {
  "use strict";

  var MOCK_HERO_PATHS = {
    "balance-complex": "v4-assets/hero/balance-complex-hero.png",
    "uti": "v4-assets/hero/uti-bottle.jpg",
    "meno-bal": "v4-assets/hero/meno-bal-hero-botanical.jpg",
    "fem-de-bloat": "v4-assets/hero/fem-de-bloat-bottle.jpg",
    "myo-d-chiro-inositol": "v4-assets/hero/myo-d-chiro-inositol-bottle.jpg",
    "flow-balance": "v4-assets/hero/flow-balance-bottle.jpg",
    "daily-balance-gummy": "v4-assets/hero/fem-gummies-bottle.jpg",
    "dim-complex": "v4-assets/hero/dim-complex-bottle.jpg",
  };
  var BALANCE_HANDLES = [
    "balance-complex",
    "uti",
    "meno-bal",
    "fem-de-bloat",
    "myo-d-chiro-inositol",
    "flow-balance",
    "daily-balance-gummy",
    "dim-complex",
  ];
  var DEFICIENCY_HANDLES = [
    "zinc-complete",
    "magnesium-complex",
    "b-complex",
    "fiber-complete",
    "calcium-complete",
    "potassium-complete",
    "choline-complete",
    "vitamin-d3-k2-complete",
    "omega-complete",
  ];
  var BALANCE_LINE_LABEL = "Feminine Balance Line";
  var DEFICIENCY_LINE_LABEL = "Feminine Deficiency Line";
  var LINE_ICON =
    '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
    '<path d="M12 2l1.8 5.5H20l-4.5 3.3 1.8 5.5L12 15.5 6.7 16.3 8.5 10.8 4 7.5h6.2z"/>' +
    "</svg>";
  var COLOR_SCHEMES = ["blue", "green", "pink", "violet"];
  var ARROW_SVG =
    '<svg width="20" height="20" viewBox="0 0 20 20" fill="none" aria-hidden="true"><path d="M17.8443 10.9707C17.9908 10.8242 18.0731 10.6255 18.0731 10.4183C18.0731 10.2112 17.9908 10.0125 17.8443 9.86599L12.8723 4.89411C12.7249 4.7518 12.5276 4.67306 12.3228 4.67483C12.1179 4.67661 11.922 4.75878 11.7771 4.90363C11.6322 5.04848 11.5501 5.24442 11.5483 5.44927C11.5465 5.65411 11.6253 5.85146 11.7676 5.9988L16.1872 10.4183L11.7676 14.8379C11.6253 14.9852 11.5465 15.1826 11.5483 15.3874C11.5501 15.5923 11.6322 15.7882 11.7771 15.933C11.922 16.0779 12.1179 16.1601 12.3228 16.1618C12.5276 16.1636 12.7249 16.0849 12.8723 15.9426L17.8443 10.9707ZM1.6665 11.1996H17.2919V9.63708H1.6665L1.6665 11.1996Z" fill="currentColor"/></svg>';

  var trigger = document.getElementById("header-products-trigger");
  var menu = document.getElementById("header-products-menu");
  var list = menu && menu.querySelector("[data-mega-menu-products]");
  var mobileBtn = document.querySelector(".header__products-btn--mobile");
  if (!trigger || !menu || !list) return;

  var mobileQuery = window.matchMedia("(max-width: 720px)");
  var content = menu.querySelector(".header-mega-menu__content");

  function ensureMobileCloseBar() {
    if (!content || content.querySelector(".header-mega-menu__mobile-bar")) return;
    var bar = document.createElement("div");
    bar.className = "header-mega-menu__mobile-bar";
    bar.innerHTML =
      '<p class="header-mega-menu__mobile-title" id="header-products-menu-title">Shop products</p>' +
      '<button type="button" class="header-mega-menu__close" aria-label="Close product list">' +
      '<span aria-hidden="true">&times;</span></button>';
    content.insertBefore(bar, list);
    bar.querySelector(".header-mega-menu__close").addEventListener("click", function (e) {
      e.preventDefault();
      closeMenu();
    });
    menu.setAttribute("aria-labelledby", "header-products-menu-title");
  }

  ensureMobileCloseBar();

  var catalogUrl =
    window.FB_CATALOG_URL ||
    (function () {
      try {
        return new URL("fb-catalog.json", document.baseURI).href;
      } catch (e) {
        return "";
      }
    })();
  var closeTimer = null;

  function fetchCatalog() {
    if (!catalogUrl) return Promise.reject(new Error("no catalog url"));

    return fetch(catalogUrl).then(function (res) {
      if (res.ok) return res.json();
      try {
        var mockUrl = new URL("data/catalog.json", document.baseURI).href;
        if (mockUrl === catalogUrl) throw new Error(String(res.status));
        return fetch(mockUrl).then(function (mockRes) {
          if (!mockRes.ok) throw new Error(String(mockRes.status));
          return mockRes.json();
        });
      } catch (err) {
        throw new Error(String(res.status));
      }
    });
  }

  function mockHeroUrl(relativePath) {
    if (!relativePath) return "";
    try {
      return new URL(relativePath, document.baseURI).href;
    } catch (e) {
      return "";
    }
  }

  function heroImageUrl(handle) {
    if (window.FB_CROSS_SELL_IMAGES && window.FB_CROSS_SELL_IMAGES[handle]) {
      return window.FB_CROSS_SELL_IMAGES[handle];
    }
    if (MOCK_HERO_PATHS[handle]) {
      return mockHeroUrl(MOCK_HERO_PATHS[handle]);
    }
    return "";
  }

  function setCardImage(card, url) {
    var media = card.querySelector(".card__image .media");
    if (!media || !url) return;
    media.innerHTML =
      '<img src="' + esc(url) + '" alt="" loading="lazy" decoding="async" />';
  }

  function hydrateCardImage(card, product) {
    var handle = product.handle;
    var url = heroImageUrl(handle);
    if (!url) {
      /* Deficiency bottles live on Shopify product media */
      return fetch("/products/" + encodeURIComponent(handle) + ".js")
        .then(function (res) {
          return res.ok ? res.json() : null;
        })
        .then(function (shopifyProduct) {
          if (shopifyProduct && shopifyProduct.featured_image) {
            var featured = shopifyProduct.featured_image;
            if (featured.indexOf("//") === 0) featured = "https:" + featured;
            setCardImage(card, featured);
          }
        })
        .catch(function () {});
    }

    return new Promise(function (resolve) {
      var probe = new Image();
      probe.onload = function () {
        setCardImage(card, url);
        resolve();
      };
      probe.onerror = function () {
        fetch("/products/" + encodeURIComponent(handle) + ".js")
          .then(function (res) {
            return res.ok ? res.json() : null;
          })
          .then(function (shopifyProduct) {
            if (shopifyProduct && shopifyProduct.featured_image) {
              var featured = shopifyProduct.featured_image;
              if (featured.indexOf("//") === 0) featured = "https:" + featured;
              setCardImage(card, featured);
            }
          })
          .catch(function () {})
          .then(resolve);
      };
      probe.src = url;
    });
  }

  function esc(str) {
    return String(str || "")
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;");
  }

  function stripHtml(str) {
    return String(str || "").replace(/<[^>]+>/g, "");
  }

  function productBlurb(product) {
    if (product.hero && product.hero.lead) return stripHtml(product.hero.lead);
    if (product.bullets && product.bullets[0]) return stripHtml(product.bullets[0]);
    return "";
  }

  function mockRating(handle) {
    var n = 0;
    for (var i = 0; i < handle.length; i++) n += handle.charCodeAt(i);
    var rating = 4.7 + (n % 4) * 0.1;
    return rating.toFixed(1);
  }

  function sortByPreferred(products, preferredFirst) {
    return products.slice().sort(function (a, b) {
      if (a.handle === preferredFirst) return -1;
      if (b.handle === preferredFirst) return 1;
      return (a.displayName || a.handle).localeCompare(b.displayName || b.handle);
    });
  }

  function productUrl(handle) {
    if (window.Shopify && window.Shopify.routes && window.Shopify.routes.root !== undefined) {
      var root = window.Shopify.routes.root || "/";
      return root + "products/" + encodeURIComponent(handle);
    }
    var store = window.FB_STORE_URL || "";
    if (store) {
      var url = store.replace(/\/$/, "") + "/products/" + encodeURIComponent(handle);
      if (window.FB_PREVIEW_THEME_ID) {
        url += "?preview_theme_id=" + encodeURIComponent(window.FB_PREVIEW_THEME_ID);
      }
      return url;
    }
    if (window.FB_PREVIEW_LOCAL) {
      var url = "/live/products/" + encodeURIComponent(handle);
      if (window.FB_PREVIEW_THEME_ID) {
        url += "?preview_theme_id=" + encodeURIComponent(window.FB_PREVIEW_THEME_ID);
      }
      return url;
    }
    return "/products/" + encodeURIComponent(handle);
  }

  function renderProductCard(product, index) {
    var name = product.displayName || product.handle;
    var imgPath = heroImageUrl(product.handle);
    var scheme = COLOR_SCHEMES[index % COLOR_SCHEMES.length];
    var rating = mockRating(product.handle);
    var href = productUrl(product.handle);
    var blurb = productBlurb(product);
    var image = imgPath
      ? '<img src="' + esc(imgPath) + '" alt="" loading="lazy" />'
      : '<span class="card-product-inline__placeholder" aria-hidden="true">' +
        esc(name.charAt(0)) +
        "</span>";

    return (
      '<li class="header-mega-menu__product">' +
      '<a href="' +
      esc(href) +
      '" class="card-product-inline card-product-inline--supplement card-product-inline--color-scheme-' +
      scheme +
      '" data-product-handle="' +
      esc(product.handle) +
      '">' +
      '<div class="card__image"><div class="media media--square">' +
      image +
      "</div></div>" +
      '<div class="card__main">' +
      '<p class="card__title">' +
      esc(name) +
      "</p>" +
      '<div class="card__reviews" aria-label="' +
      esc(rating) +
      ' out of 5 stars">' +
      '<span class="card__stars" aria-hidden="true">★★★★★</span>' +
      '<span class="card__rating">' +
      esc(rating) +
      "</span>" +
      "</div>" +
      '<p class="card__text">' +
      esc(blurb) +
      "</p>" +
      "</div>" +
      '<div class="card__arrow">' +
      ARROW_SVG +
      "</div>" +
      "</a></li>"
    );
  }

  function renderGroup(label, products, chipModifier, startIndex) {
    if (!products.length) return "";
    var cards = products
      .map(function (product, index) {
        return renderProductCard(product, startIndex + index);
      })
      .join("");

    return (
      '<li class="header-mega-menu__group' +
      (chipModifier ? " " + chipModifier : "") +
      '">' +
      '<span class="v4-pdp__use-chip v4-pdp__use-chip--line header-mega-menu__line-chip">' +
      LINE_ICON +
      esc(label) +
      "</span>" +
      '<ul class="header-mega-menu__group-list" role="list">' +
      cards +
      "</ul></li>"
    );
  }

  function renderProducts(balanceProducts, deficiencyProducts) {
    var balanceSorted = sortByPreferred(balanceProducts, "balance-complex");
    var deficiencySorted = sortByPreferred(deficiencyProducts, "zinc-complete");

    list.innerHTML =
      renderGroup(BALANCE_LINE_LABEL, balanceSorted, "header-mega-menu__group--balance", 0) +
      renderGroup(
        DEFICIENCY_LINE_LABEL,
        deficiencySorted,
        "header-mega-menu__group--deficiency",
        balanceSorted.length
      );

    balanceSorted.concat(deficiencySorted).forEach(function (product) {
      var card = list.querySelector(
        'a.card-product-inline[data-product-handle="' + product.handle + '"]'
      );
      if (card) hydrateCardImage(card, product);
    });
  }

  function isMobileView() {
    return mobileQuery.matches;
  }

  function syncMenuScrollLock() {
    var overlayOpen = document.querySelector(".overlay.expanded");
    var megaOpen = menu.classList.contains("is-open") && isMobileView();
    document.documentElement.classList.toggle("fb-mega-menu-open", megaOpen);
    if (megaOpen || overlayOpen) {
      document.documentElement.style.overflow = "hidden";
      document.body.style.overflow = "hidden";
    } else {
      document.documentElement.style.overflow = "";
      document.body.style.overflow = "";
    }
  }

  function openMenu() {
    clearTimeout(closeTimer);
    menu.classList.add("is-open");
    menu.setAttribute("aria-hidden", "false");
    trigger.setAttribute("aria-expanded", "true");
    if (mobileBtn) mobileBtn.setAttribute("aria-expanded", "true");
    syncMenuScrollLock();
  }

  function closeMenu() {
    menu.classList.remove("is-open");
    menu.setAttribute("aria-hidden", "true");
    trigger.setAttribute("aria-expanded", "false");
    if (mobileBtn) mobileBtn.setAttribute("aria-expanded", "false");
    syncMenuScrollLock();
  }

  function toggleMenu() {
    if (menu.classList.contains("is-open")) closeMenu();
    else openMenu();
  }

  function scheduleClose() {
    clearTimeout(closeTimer);
    closeTimer = setTimeout(closeMenu, 120);
  }

  if (!catalogUrl) {
    list.innerHTML =
      '<li class="header-mega-menu__product"><p class="card__text">Products unavailable.</p></li>';
    return;
  }

  fetchCatalog()
    .then(function (catalog) {
      var all = catalog.products || [];
      var balance = all.filter(function (p) {
        return BALANCE_HANDLES.indexOf(p.handle) !== -1;
      });
      var deficiency = all.filter(function (p) {
        return DEFICIENCY_HANDLES.indexOf(p.handle) !== -1;
      });
      renderProducts(balance, deficiency);
    })
    .catch(function () {
      list.innerHTML =
        '<li class="header-mega-menu__product"><p class="card__text">Products unavailable.</p></li>';
    });

  trigger.addEventListener("mouseenter", function () {
    if (!isMobileView()) openMenu();
  });
  trigger.addEventListener("focus", function () {
    if (!isMobileView()) openMenu();
  });
  menu.addEventListener("mouseenter", function () {
    if (!isMobileView()) openMenu();
  });
  trigger.addEventListener("mouseleave", function () {
    if (!isMobileView()) scheduleClose();
  });
  menu.addEventListener("mouseleave", function () {
    if (!isMobileView()) scheduleClose();
  });

  trigger.addEventListener("click", function (e) {
    e.preventDefault();
    if (isMobileView()) toggleMenu();
    else if (!menu.classList.contains("is-open")) openMenu();
  });

  if (mobileBtn) {
    mobileBtn.addEventListener("click", function (e) {
      e.preventDefault();
      toggleMenu();
    });
  }

  document.addEventListener("click", function (e) {
    if (!menu.classList.contains("is-open")) return;
    if (menu.contains(e.target) || trigger.contains(e.target)) return;
    if (mobileBtn && mobileBtn.contains(e.target)) return;
    closeMenu();
  });

  mobileQuery.addEventListener("change", function () {
    if (!isMobileView()) {
      document.documentElement.classList.remove("fb-mega-menu-open");
      document.documentElement.style.overflow = "";
      document.body.style.overflow = "";
      syncMenuScrollLock();
    } else if (!menu.classList.contains("is-open")) {
      syncMenuScrollLock();
    }
  });

  trigger.addEventListener("keydown", function (e) {
    if (e.key === "Escape") closeMenu();
  });

  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape" && menu.classList.contains("is-open")) closeMenu();
  });

  list.addEventListener("click", function (e) {
    var link = e.target.closest("a.card-product-inline");
    if (!link) return;
    var href = link.getAttribute("href") || "";
    if (!href || href.charAt(0) === "#") return;
    e.preventDefault();
    closeMenu();
    window.location.assign(link.href);
  });
})();
